import DiagnosticEntryCanceled from "../components/tabs/ForwardingsTabs/Entries/DiagnosticEntry/Status/Canceled";
import DiagnosticEntryCompleted from "../components/tabs/ForwardingsTabs/Entries/DiagnosticEntry/Status/Completed";
import DiagnosticEntryOnGoingCheckin from "../components/tabs/ForwardingsTabs/Entries/DiagnosticEntry/Status/OnGoingCheckin";
import DiagnosticEntryOnGoingDirective from "../components/tabs/ForwardingsTabs/Entries/DiagnosticEntry/Status/OnGoingDirective";
import DiagnosticEntryOnGoingEstablishmentChoice from "../components/tabs/ForwardingsTabs/Entries/DiagnosticEntry/Status/OnGoingEstablishmentChoice";
import ExecutionEntryCanceled from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/Canceled";
import ExecutionEntryCompleted from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/Completed";
import ExecutionEntryOnGoingCheckin from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/OnGoingCheckin";
import ExecutionEntryOnGoingDirective from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/OnGoingDirective";
import ExecutionEntryOnGoingEstablishmentChoice from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/OnGoingEstablishmentChoice";
import ExecutionEntryOnGoingFinancialReview from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/OnGoingFinancialReview";
import OnGoingFiscalAssessment from "../components/tabs/ForwardingsTabs/Entries/ExecutionEntry/Status/OnGoingFiscalAssessment";
import { MaintenanceForwardingStatus } from "../features/forwardings/types/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";

export const maintenanceForwardingsDirectiveEntryKlasses: Partial<{
  [DirectiveEntry in MaintenanceForwardingsDirectiveEntryKlass]: {
    label: string;
    status: Partial<{
      [Status in MaintenanceForwardingStatus]: {
        label: string;
        component: React.ComponentType;
      }
    }>
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    label: 'Diagnóstico e Orçamento',
    status: {
      canceled: {
        label: 'Declinado',
        component: DiagnosticEntryCanceled,
      },
      completed: {
        label: 'Finalizado',
        component: DiagnosticEntryCompleted,
      },
      ongoing_checkin: {
        label: 'Pendente de check-in',
        component: DiagnosticEntryOnGoingCheckin,
      },
      ongoing_establishment_choice: {
        label: 'Aguardando resposta do estabelecimento',
        component: DiagnosticEntryOnGoingEstablishmentChoice,
      },
      ongoing_directive: {
        label: 'Análise de diagnóstico e orçamento',
        component: DiagnosticEntryOnGoingDirective,
      },
    },
  },
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: {
    label: 'Execução',
    status: {
      canceled: {
        label: 'Declinado',
        component: ExecutionEntryCanceled,
      },
      completed: {
        label: 'Finalizado',
        component: ExecutionEntryCompleted,
      },
      ongoing_checkin: {
        label: 'Pendente de check-in',
        component: ExecutionEntryOnGoingCheckin,
      },
      ongoing_establishment_choice: {
        label: 'Aguardando resposta do estabelecimento',
        component: ExecutionEntryOnGoingEstablishmentChoice,
      },
      ongoing_directive: {
        label: 'Aguardando execução',
        component: ExecutionEntryOnGoingDirective,
      },
      ongoing_financial_review: {
        label: 'Análise financeira',
        component: ExecutionEntryOnGoingFinancialReview,
      },
      ongoing_fiscal_assessment: {
        label: 'Análise de notas fiscais',
        component: OnGoingFiscalAssessment,
      },
    },
  },
}
